import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

import user from 'js/lib/user';

import type {
  degreeMemberships as DegreeMembershipsQueryData,
  degreeMembershipsVariables as DegreeMembershipsQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__generated__/degreeMemberships';

const DegreeLearnerMembershipsQuery = gql`
  query degreeMemberships($userId: String!) {
    DegreeLearnerMembershipsV1Resource {
      byUser(userId: $userId) {
        elements {
          id
          role
          degree {
            name
            slug
            id
            logo
          }
        }
      }
    }
  }
`;

export const useDegreeLearnerMemberships = () => {
  const userId = user.get()?.id?.toString() ?? '';

  const variables: DegreeMembershipsQueryVariables = {
    userId,
  };

  return useQuery<DegreeMembershipsQueryData, DegreeMembershipsQueryVariables>(DegreeLearnerMembershipsQuery, {
    variables,
    context: { clientName: 'gatewayGql' },
  });
};

export default useDegreeLearnerMemberships;
